import React, { useMemo, useState, ComponentProps } from 'react'
import { SerializedStyles, css } from '@emotion/core'

type Props = ComponentProps<'div'> & {
  value: string
  customStyle?: SerializedStyles
  aspect?: number
}

export const UploadFileImage: React.FC<Props> = ({ value, aspect, customStyle, ...props }) => {
  const [isShowPreview, setIsShowPreview] = useState<boolean>(false)

  const widthRate = useMemo(() => (aspect && aspect > 1 ? aspect : 1), [aspect])
  const heightRate = useMemo(() => (aspect && aspect <= 1 ? aspect : 1), [aspect])

  const pictureBackgroundSizeStyle = useMemo(() => {
    return css({
      width: 80 * widthRate,
      height: 80 * heightRate,
      '.uploaded-picture, .upload-place-picture': {
        position: 'absolute',
        width: 80 * widthRate,
        height: 80 * heightRate,
      },
    })
  }, [widthRate, heightRate])

  return (
    <>
      <div css={[pictureBackgroundStyle, pictureBackgroundSizeStyle, customStyle]} onClick={() => setIsShowPreview(true)} {...props}>
        <div className="uploaded-picture" style={{ backgroundImage: `url(${value})` }}></div>
        <div className="uploaded-picture" style={{ border: '1px solid #CCCCCC' }}></div>
      </div>
      {isShowPreview && (
        <div css={previewPhotoStyle}>
          <div className="background-overlay" onClick={() => setIsShowPreview(false)}>
            <img className="preview-photo" src={value} alt="" />
          </div>
        </div>
      )}
    </>
  )
}

const pictureBackgroundStyle = css({
  position: 'relative',
  '.uploaded-picture, .upload-place-picture': {
    position: 'absolute',
    borderRadius: 5,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    cursor: 'pointer',
  },
  '.uploaded-picture': {
    backgroundSize: 'cover',
  },
  '.upload-place-picture': {
    backgroundImage: `url(${require('@/static/images/camera_icon_white.svg')})`,
    backgroundSize: 17,
  },
})

const previewPhotoStyle = css({
  '.background-overlay': {
    position: 'fixed',
    zIndex: 10000,
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
  },
  '.preview-photo': {
    margin: '32px auto',
  },
})
